import { gql } from "@apollo/client"

const GET_SES_EMAILS = gql`
  query($input: SesEmailsInput!, $perPage: Int!, $page: Int!) {
    sesEmails(input: $input, first: $perPage, page: $page) {
      data {
        id
        message_id
        email
        created_at
        updated_at
        status {
          id
          name
          description
          is_failed
          is_delivered
          is_unknown
          is_queued
        }
      }

      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastPage
        total
      }
    }
  }
`

export { GET_SES_EMAILS }